import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
} from '@angular/core';
import { fromEvent, merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductService } from '../services/product.service';
import { IProduct } from '../interfaces/product';

import { AppSettings } from '../appSettings';

import { Subscription } from 'rxjs';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IOption } from '../interfaces/option';
import { AppFormat } from '../appFormat';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SearchService } from '../services/search.service';
import { IImage } from '../interfaces/image';
import { ICategory } from '../interfaces/category';
import { CategoryService } from '../services/category.service';
import { ExportExcelService } from '../services/export-excel.service';
import { ImportFileComponent } from '../components/import-file/import-file.component';

import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { ProductDetailComponent } from '../product-detail/product-detail.component';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss'],
  host: { class: 'wrapper-stock' },
})
export class StockComponent implements OnInit {
  @ViewChild('searchFilter') searchFilter: ElementRef<HTMLDivElement>;
  @ViewChild(ImportFileComponent) importFileCmp: ImportFileComponent;
  @ViewChild(ProductDetailComponent) productDetailCmp: ProductDetailComponent;

  faFileImport = faFileImport;

  // public num_ativos: number = 0
  public num_todos: number = 0;
  public num_promocao: number = 0;
  // public num_baixo_estoque: number = 0;
  public num_sem_estoque: number = 0;

  public openid: number = 0;
  public photo_number: number = 1;
  public photo_number_url: string = '';

  public page: number = 1;

  public tab: string = 'todos';

  public open: boolean = false;
  public openPrice: boolean = false;
  public openStoke: boolean = false;

  public loadingProduct: boolean = false;
  public loadingDetail: boolean = false;
  public loadingTab: boolean = false;
  public changeDetail: boolean = false;
  public hasOffer: boolean = false;
  public hasLowerStoke: boolean = false;
  public hasOutOfStock: boolean = false;
  public optionOpen: boolean = false;

  public optionTimeout: any = null;

  public products: IProduct[];
  public product: IProduct;
  public product_idx: number;

  private query;

  public URL_IMG_PRODUTO: string = AppSettings.URL_IMG_PRODUTO;

  public produtoFrm: FormGroup;

  public preco: FormControl;
  public estoque: FormControl;
  public sem_limite: FormControl;
  public limite_minimo_estoque: FormControl;
  public max_pr_cliente: FormControl;

  public oferta_id: FormControl;
  public oferta_preco: FormControl;
  public oferta_obs: FormControl;
  public oferta_validade_inicial: FormControl;
  public oferta_validade_final: FormControl;
  public oferta_validade_inicial_hora: FormControl;
  public oferta_validade_final_hora: FormControl;
  public oferta_max_pr_cliente: FormControl;

  public option_validade_inicial: FormControl;
  public option_validade_final: FormControl;

  public status_ativo: FormControl;
  public status_inativo: FormControl;

  public oferta_off: number = 0;

  public permanencia_inicio: IOption[] = [];
  public permanencia_fim: IOption[] = [];

  public subscribeSearch: Subscription;

  public search: string = '';
  private timeoutSearch = null;

  minDate = new Date();
  startDate = new Date();

  selector: string = '.wrapper-stock';

  public lower_stock: number = 3;

  private estoque_bk;

  public showFilter: boolean = false;

  public filterFrm: FormGroup;

  public categories: ICategory[];

  public categorias: FormControl;
  public sem_descricao: FormControl;
  public com_descricao: FormControl;
  public sem_fotos: FormControl;
  public uma_foto: FormControl;
  public varias_foto: FormControl;

  private _document;
  private subscribeSearchFilter: Subscription;
  public _destroy$: Subject<any>;

  public isExportLoading: boolean = false;
  public modalExportOpen: boolean = false;

  public changedImportFileCmp: boolean = false;
  public modalImportOpen: boolean = false;

  public isMobile: boolean = false;

  constructor(
    private _productService: ProductService,
    private _searchService: SearchService,
    private _zone: NgZone,
    private _categoryService: CategoryService,
    private _exportExcelService: ExportExcelService
  ) {
    this.query = { page: this.page };

    this.categories = [];

    this._destroy$ = new Subject();

    this.product = {
      descricao: '',
    };

    let option_hoje = { text: 'Hoje', value: 'H' };
    this.permanencia_inicio.push(option_hoje);
    //this.permanencia_fim.push(option_hoje)

    let option_nodia = { text: 'No dia', value: 'D' };
    this.permanencia_inicio.push(option_nodia);
    this.permanencia_fim.push(option_nodia);

    this._document = document.getElementsByTagName('body');
    //
    //this._searchService._searchProduct.unsubscribe();
    this.subscribeSearch = this._searchService._searchProduct.subscribe(
      (res) => {
        this.search = res;
        if (this.timeoutSearch) clearTimeout(this.timeoutSearch);

        this.timeoutSearch = setTimeout(() => {
          this.loadingTab = true;
          // this.num_ativos = 0
          this.num_todos = 0;
          // this.num_baixo_estoque = 0;
          this.num_promocao = 0;
          this.num_sem_estoque = 0;
          this.closeDetail();
          this.changeTab('todos');
        }, 300);
      }
    );

    this.subscribeSearchFilter = this._searchService._searchFilter.subscribe(
      (res) => {
        if (res.action == 'product') {
          this.searchFilter.nativeElement.style.width =
            res['payload']['target']['offsetLeft'] + 26 + 'px';

          //roda fora do sistema de atualizacao do angular. melhora a otimizacao
          this._zone.runOutsideAngular(() => {
            merge(
              fromEvent(this._document, 'touchstart', { capture: true }),
              fromEvent(this._document, 'mousedown', { capture: true })
            )
              .pipe(takeUntil(this._destroy$))
              .subscribe(($event) => this._checkToClose($event));
          });

          this.showFilter = true;
        }
      }
    );
  }

  _checkToClose($event) {
    if (this.searchFilter.nativeElement.contains($event.target)) {
      return;
    }

    /** @type {?} */
    const path = $event.path || ($event.composedPath && $event.composedPath());
    if (
      $event.target &&
      $event.target.shadowRoot &&
      path &&
      path[0] &&
      this.searchFilter.nativeElement.contains(path[0])
    ) {
      return;
    }

    let dtcalendar = document.getElementsByClassName(
      'cdk-overlay-container'
    )[0];

    if (dtcalendar && dtcalendar.contains(path[0])) {
      return;
    }

    if (path[0].classList.contains('cdk-overlay-backdrop')) {
      return;
    }

    //como este código roda fora do sistema de alteração do angular. é preciso enviar o comando para o angular
    this._zone.run(() => {
      this.showFilter = false;
    });
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();

    this.loadingTab = true;
    this.changeTab('todos');

    this._categoryService.getAll().subscribe((data) => {
      this.categories = data.categorias;
      for (let j in this.categories) {
        this.categories[j].selected = false;
      }
    });

    this.isMobile = screen.width < 480;

    this.open = false;
  }

  ngOnDestroy(): void {
    this.subscribeSearch.unsubscribe();

    this.subscribeSearchFilter.unsubscribe();

    this._destroy$.next();
    this._destroy$.complete();
    this._destroy$.unsubscribe();
  }

  createFormControls() {
    this.preco = new FormControl('', [Validators.required]);
    this.estoque = new FormControl('');

    this.sem_limite = new FormControl(false);
    this.limite_minimo_estoque = new FormControl('');

    this.oferta_id = new FormControl(null);
    this.oferta_preco = new FormControl('');
    this.oferta_obs = new FormControl('');
    this.oferta_validade_inicial = new FormControl('');
    this.oferta_validade_final = new FormControl('');

    this.oferta_validade_inicial_hora = new FormControl('00:00:00');
    this.oferta_validade_final_hora = new FormControl('23:59:59');

    this.max_pr_cliente = new FormControl(null);
    this.oferta_max_pr_cliente = new FormControl('');

    this.option_validade_inicial = new FormControl('');
    this.option_validade_final = new FormControl('');

    //
    //

    this.categorias = new FormControl(null);
    this.sem_descricao = new FormControl(null);
    this.com_descricao = new FormControl(null);
    this.sem_fotos = new FormControl(null);
    this.uma_foto = new FormControl(null);
    this.varias_foto = new FormControl(null);

    this.status_ativo = new FormControl(true);
    this.status_inativo = new FormControl(true);
  }

  createForm() {
    this.produtoFrm = new FormGroup({
      preco: this.preco,
      estoque: this.estoque,
      sem_limite: this.sem_limite,
      limite_minimo_estoque: this.limite_minimo_estoque,
      oferta_preco: this.oferta_preco,
      oferta_obs: this.oferta_obs,
      max_pr_cliente: this.max_pr_cliente,
      oferta_id: this.oferta_id,
      oferta_validade_inicial: this.oferta_validade_inicial,
      oferta_validade_final: this.oferta_validade_final,
      oferta_validade_inicial_hora: this.oferta_validade_inicial_hora,
      oferta_validade_final_hora: this.oferta_validade_final_hora,
      oferta_max_pr_cliente: this.oferta_max_pr_cliente,
      option_validade_inicial: this.option_validade_inicial,
      option_validade_final: this.option_validade_final,
    });

    this.filterFrm = new FormGroup({
      categorias: this.categorias,
      sem_descricao: this.sem_descricao,
      com_descricao: this.com_descricao,
      sem_fotos: this.sem_fotos,
      uma_foto: this.uma_foto,
      varias_foto: this.varias_foto,
      status_ativo: this.status_ativo,
      status_inativo: this.status_inativo,
    });
  }

  ajustUrl(url) {
    return url.replace(
      AppSettings.URL_IMG_PRODUTO,
      AppSettings.URL_S3_IMG_PRODUTO
    );
  }

  onExport() {
    this.isExportLoading = true;
    setTimeout(() => {
      this.modalExportOpen = true;
    }, 100);

    //let idpedido_situacao = this.query['idpedido_situacao']
    //delete this.query['idpedido_situacao']

    let page = this.query['page'];

    this.query['all_pages'] = 'true';

    this._productService.search(this.query).subscribe((data) => {
      let products = data.data;

      if (products.length > 0) {
        let dataForExcel = [];

        for (let i in products) {
          products[i]['codbarra'] = products[i]['codbarra'] + '';

          products[i]['preco'] = AppFormat.number(products[i]['preco']);
          products[i]['oferta_preco'] = AppFormat.number(
            products[i]['oferta_preco']
          );
          products[i]['peso_liquido'] = AppFormat.number(
            products[i]['peso_liquido']
          );

          delete products[i]['idest'];
        }

        products.forEach((row: any) => {
          dataForExcel.push(Object.values(row));
        });

        let title = 'Produtos';

        let reportData = {
          title: title,
          data: dataForExcel,
          headers: Object.keys(products[0]),
        };

        this._exportExcelService.exportExcel(reportData);
      } else {
        Swal.fire(
          'Ops!',
          'Não há nenhuma informação para ser exportada. Selecione outro filtro!',
          'error'
        );
      }

      this.modalExportOpen = false;
      setTimeout(() => {
        this.isExportLoading = false;
      }, 300);

      delete this.query['all_pages'];
      this.query['page'] = page;
      //this.query['idpedido_situacao'] = idpedido_situacao
    });
  }

  onClearFilter() {
    this.categorias.setValue([]);
    this.sem_descricao.setValue(null);
    this.com_descricao.setValue(null);
    this.sem_fotos.setValue(null);
    this.uma_foto.setValue(null);
    this.varias_foto.setValue(null);
    this.onSubmitFilter();
  }

  onSubmitFilter() {
    this.changeTab(this.tab);
    this.showFilter = false;
  }

  onScroll() {
    if (!this.loadingProduct) {
      this.page = this.page + 1;
      this.find();
    }
  }

  find() {
    this.loadingProduct = true;

    this.query['page'] = this.page;

    if (this.search != '') {
      this.query['search'] = this.search;
    } else {
      if (this.query['search']) {
        delete this.query['search'];
      }
    }

    //str: string, sort: string, direction: string, page: number

    this._productService.search(this.query).subscribe((res) => {
      this.products = this.page > 1 ? this.products.concat(res.data) : res.data;

      if (res.num_todos === 0 || res.num_todos > 0) {
        this.num_todos = res.num_todos;
        // this.num_ativos = res.num_ativos
        // this.num_baixo_estoque = res.num_baixo_estoque;
        this.num_promocao = res.num_promocao;
        this.num_sem_estoque = res.num_sem_estoque;
      }

      this.loadingProduct = false;
      this.loadingTab = false;
    });
  }

  toggleOptions(): void {
    this.optionOpen = !this.optionOpen;

    this.clearOptions();
  }

  hideOptions(): void {
    if (this.optionOpen) {
      if (this.optionTimeout) clearTimeout(this.optionTimeout);

      this.optionTimeout = setTimeout(() => {
        this.optionOpen = false;
      }, 2000);
    }
  }

  clearOptions(): void {
    if (this.optionTimeout) clearTimeout(this.optionTimeout);
  }

  changeTab(tab): void {
    this.tab = tab;
    this.page = 1;

    this.loadingTab = true;

    delete this.query['estoque'];
    delete this.query['em_promocao'];
    delete this.query['in_idcategoria'];
    delete this.query['sem_descricao'];
    delete this.query['com_descricao'];
    delete this.query['status'];
    delete this.query['sem_fotos'];
    delete this.query['only_active'];

    switch (tab) {
      case 'promocao':
        this.query['em_promocao'] = 'S';
        break;
      case 'baixo-estoque':
        this.query['estoque'] = this.lower_stock;
        break;
      case 'sem-estoque':
        this.query['estoque'] = 0;
    }

    if (
      (this.status_ativo.value && this.status_inativo.value) ||
      (!this.status_ativo.value && !this.status_inativo.value)
    ) {
      //
    } else if (this.status_ativo.value) {
      this.query['status'] = 'A';
    } else if (this.status_inativo.value) {
      this.query['status'] = 'I';
    }

    if (this.categorias.value != null && this.categorias.value.length > 0) {
      this.query['in_idcategoria'] = this.categorias.value;
    }

    if (this.sem_descricao.value) {
      this.query['sem_descricao'] = 'S';
    }

    if (this.com_descricao.value) {
      this.query['com_descricao'] = 'S';
    }

    if (this.sem_fotos.value) {
      this.query['sem_fotos'] = 'S';
    }

    this.find();
  }

  cancelEdit(): void {
    Swal.fire({
      title: 'Você deseja cancelar as alterações?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.openDetail(this.product, this.product_idx);
        this.openPrice = false;
        this.openStoke = false;
      }
    });
  }

  onUnlimitedStock(): void {
    if (this.estoque_bk != null) {
      this.estoque.setValue(this.estoque_bk);
      this.estoque_bk = null;
    } else {
      this.estoque_bk = this.estoque.value;
      this.estoque.setValue(null);
    }
    this.onChangeDetail();
  }

  openDetail(product: IProduct, i: number) {
    document.getElementById('detailProduct').scrollTop = 0;

    this.open = true;

    if (this.isMobile) {
      this.productDetailCmp.getProductID(product.idproduto_geral);
    } else {
      this.product = product;
      this.product_idx = i;

      this.openid = product.idproduto_estabelecimento;

      this.loadingDetail = true;

      this.changeDetail = false;

      this.hasOffer = false;
      this.hasLowerStoke = false;
      this.hasOutOfStock = false;
      this.estoque_bk = null;

      this._productService
        .findUsingId(product.idproduto_estabelecimento)
        .subscribe((res) => {
          this.loadingDetail = false;

          this.product = res;

          this.preco.setValue(this.product.preco);
          this.sem_limite.setValue(false);

          if (this.product.estoque > 0) {
            this.estoque.setValue(this.product.estoque);
          } else {
            this.estoque.setValue(null);
          }

          this.sem_limite.setValue(this.product.estoque_infinito == 'S');

          if (this.product.limite_minimo_estoque >= 0) {
            this.limite_minimo_estoque.setValue(
              this.product.limite_minimo_estoque
            );
          } else {
            this.limite_minimo_estoque.setValue(null);
          }

          if (this.product.max_pr_cliente >= 0) {
            this.max_pr_cliente.setValue(this.product.max_pr_cliente);
          } else {
            this.max_pr_cliente.setValue(null);
          }

          if (
            this.product.estoque <= this.lower_stock &&
            this.product.estoque > 0
          ) {
            this.hasLowerStoke = true;
          }
          if (this.product.estoque <= 0) {
            this.hasOutOfStock = true;
          }

          if (this.product.ofertas && this.product.ofertas.length > 0) {
            this.hasOffer = true;

            let oferta = this.product.ofertas[0];

            this.oferta_id.setValue(oferta.idoferta);

            this.oferta_preco.setValue(oferta.preco);

            this.oferta_obs.setValue(oferta.obs);

            this.oferta_off = parseFloat(
              (100 - (oferta.preco * 100) / this.product.preco).toFixed(0)
            );

            let validade_inicial = oferta.validade_inicial.split(' ');
            if (validade_inicial.length > 0) {
              this.oferta_validade_inicial.setValue(
                AppFormat.dateYMDUTCMoment(validade_inicial[0])
              );
              this.oferta_validade_inicial_hora.setValue(validade_inicial[1]);
            }

            let validade_final = oferta.validade_final.split(' ');
            if (validade_final.length > 0) {
              this.oferta_validade_final.setValue(
                AppFormat.dateYMDUTCMoment(validade_final[0])
              );
              this.oferta_validade_final_hora.setValue(validade_final[1]);
            }

            this.option_validade_inicial.setValue('D');
            this.option_validade_final.setValue('D');

            if (this.max_pr_cliente.value == null) {
              if (oferta.max_pr_cliente >= 0) {
                this.max_pr_cliente.setValue(oferta.max_pr_cliente);
              } else {
                this.max_pr_cliente.setValue(null);
              }
            }
          } else {
            this.oferta_preco.setValue(0);

            this.oferta_obs.setValue('');

            this.oferta_off = 0;

            this.oferta_id.setValue(null);

            this.oferta_validade_inicial.setValue(null);
            this.oferta_validade_final.setValue(null);

            this.oferta_validade_inicial_hora.setValue('00:00:00');
            this.oferta_validade_final_hora.setValue('23:59:59');

            this.option_validade_inicial.setValue('');
            this.option_validade_final.setValue('');
          }

          if (this.product.images && this.product.images.length > 0) {
            this.photo_number_url = this.product.images[0].default;
          } else {
            this.photo_number_url = null;
          }
        });
    }
  }

  updatePerc() {
    if (this.preco.value == undefined) {
      this.preco.setValue(0);
    }

    if (this.oferta_preco.value != undefined && this.preco.value > 0) {
      if (parseFloat(this.preco.value) > parseFloat(this.oferta_preco.value)) {
        this.oferta_off = parseFloat(
          (
            100 -
            (parseFloat(this.oferta_preco.value) * 100) /
              parseFloat(this.preco.value)
          ).toFixed(0)
        );
      } else {
        this.oferta_off = 0;
      }
    } else {
      this.oferta_preco.setValue(0);
      this.oferta_off = 0;
    }

    this.onChangeDetail();
  }

  closeDetail() {
    this.open = false;
  }

  newProductDetail() {
    this.open = true;

    this.product = null;
    this.product_idx = null;

    this.openid = null;

    this.loadingDetail = false;

    this.changeDetail = false;

    this.hasOffer = false;
    this.hasLowerStoke = false;
    this.hasOutOfStock = false;
    this.estoque_bk = null;

    this.productDetailCmp.openNewProduct();
  }

  onCloseDetailEvent() {
    this.closeDetail();
  }

  onChangeDetailEvent(product: IProduct) {
    //
    for (let i in this.products) {
      if (this.products[i].idproduto_geral == product.idproduto_geral) {
        for (let j in product) {
          this.products[i][j] = product[j];
        }
        break;
      }
    }
  }

  selectPhoto(image: IImage) {
    this.photo_number_url = image.default;
  }

  selectedDTInicio() {
    if (this.option_validade_inicial.value == 'H') {
      /*
      let dt = new Date()
      alert(dt)
      alert(dt.getFullYear()+' '+dt.getMonth()+' '+dt.getDate())
      alert(Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate(), dt.getUTCHours(), dt.getUTCMinutes()))
      alert(AppFormat.nowUTC())
      alert(dt.toUTCString())
      */

      this.oferta_validade_inicial.setValue(AppFormat.nowUTCMoment());
      //this.oferta_validade_inicial.setValue(new Date())
    }
    this.onChangeDetail();
  }

  onChangeDetail() {
    this.changeDetail = true;
  }

  mensagemError() {
    let msg = [];

    if (
      (this.preco.invalid && (this.preco.dirty || this.preco.touched)) ||
      this.preco.value == ''
    ) {
      msg.push('Você precisa preencher o valor do produto!');
    }

    if (
      (this.oferta_validade_inicial.invalid &&
        (this.oferta_validade_inicial.dirty ||
          this.oferta_validade_inicial.touched)) ||
      this.oferta_validade_inicial.value == ''
    ) {
      msg.push('Você precisa preencher uma data inicial válida!');
    }

    if (
      (this.oferta_validade_final.invalid &&
        (this.oferta_validade_final.dirty ||
          this.oferta_validade_final.touched)) ||
      this.oferta_validade_final.value == ''
    ) {
      msg.push('Você precisa preencher uma data final válida!');
    }

    if (msg.length == 0) {
      msg.push('Você precisa preencher os dados do produto!');
    }

    Swal.fire('Ops!', msg.join('<br>'), 'error');
  }

  ofertaValid() {
    let has = true;

    let msg = [];

    if (this.oferta_preco.value != '' && this.oferta_preco.value > 0) {
      if (
        this.oferta_obs.value != '' ||
        this.oferta_validade_inicial.value != '' ||
        this.oferta_validade_final.value != ''
      ) {
        //console.log(this.oferta_validade_inicial.invalid, this.oferta_validade_inicial.dirty, this.oferta_validade_inicial.touched, this.oferta_validade_inicial.value)

        if (
          (this.oferta_validade_inicial.invalid &&
            (this.oferta_validade_inicial.dirty ||
              this.oferta_validade_inicial.touched)) ||
          this.oferta_validade_inicial.value == '' ||
          this.oferta_validade_inicial.value == null
        ) {
          msg.push('Você precisa preencher uma data inicial da oferta válida!');
          has = false;
        }

        if (
          (this.oferta_validade_final.invalid &&
            (this.oferta_validade_final.dirty ||
              this.oferta_validade_final.touched)) ||
          this.oferta_validade_final.value == '' ||
          this.oferta_validade_final.value == null
        ) {
          msg.push('Você precisa preencher uma data final da oferta válida!');
          has = false;
        }

        if (msg.length > 0) {
          Swal.fire('Ops!', msg.join('<br>'), 'error');
        }
      }
    }

    return has;
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplate() {
    Swal.fire('Salvo!', 'O produto foi salvo', 'success');
  }

  onSubmit() {
    if (this.produtoFrm.valid) {
      if (!this.ofertaValid()) return false;

      let dtinicial,
        dtfinal = '';
      if (
        this.oferta_validade_inicial.value != null &&
        typeof this.oferta_validade_inicial.value === 'object'
      ) {
        dtinicial = this.oferta_validade_inicial.value.format('YYYY-MM-DD');
      } else {
        dtinicial = this.oferta_validade_inicial.value;
      }

      if (
        this.oferta_validade_final.value != null &&
        typeof this.oferta_validade_final.value === 'object'
      ) {
        dtfinal = this.oferta_validade_final.value.format('YYYY-MM-DD');
      } else {
        dtfinal = this.oferta_validade_final.value;
      }

      let data = {
        preco: this.preco.value,
        estoque: this.estoque.value,
        estoque_infinito: this.sem_limite.value ? 'S' : 'N',
        limite_minimo_estoque: this.limite_minimo_estoque.value,
        idproduto_geral: this.product.idproduto_geral,
        max_pr_cliente: this.max_pr_cliente.value,
        oferta_id: this.oferta_id.value,
        oferta_preco: this.oferta_preco.value,
        oferta_validade_inicial: dtinicial,
        oferta_validade_inicial_hora: this.oferta_validade_inicial_hora.value,
        oferta_validade_final: dtfinal,
        oferta_validade_final_hora: this.oferta_validade_final_hora.value,
        oferta_obs: this.oferta_obs.value,
        oferta_max_pr_cliente: this.max_pr_cliente.value,
      };

      Swal.fire({
        title: 'Salvando...',
        icon: 'info',
        showCancelButton: false,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      this.storeProduct(data);
    } else {
      this.mensagemError();
    }
    return null;
  }

  storeProduct(data) {
    this._productService.store(data).subscribe(
      (res) => {
        if (res['success']) {
          this.changeDetail = false;

          for (let i in this.products) {
            if (
              this.products[i].idproduto_estabelecimento ==
              this.product.idproduto_estabelecimento
            ) {
              this.products[i].preco = data.preco;
              this.products[i].estoque = data.estoque;

              // this.products[i].oferta_preco = data.oferta_preco;

              break;
            }
          }

          if (this.hasOffer && data.oferta_preco == 0) {
            this.num_promocao = this.num_promocao - 1;
          } else if (!this.hasOffer && data.oferta_preco > 0) {
            this.num_promocao = this.num_promocao + 1;
          }

          // if (
          //   this.hasLowerStoke &&
          //   (this.estoque.value > this.lower_stock || this.estoque.value == 0)
          // ) {
          //   this.num_baixo_estoque = this.num_baixo_estoque - 1;
          // } else if (
          //   !this.hasLowerStoke &&
          //   this.estoque.value > 0 &&
          //   this.estoque.value <= this.lower_stock
          // ) {
          //   this.num_baixo_estoque = this.num_baixo_estoque + 1;
          // }

          if (this.hasOutOfStock && this.estoque.value > 0) {
            this.num_sem_estoque = this.num_sem_estoque - 1;
          } else if (!this.hasOutOfStock && this.estoque.value <= 0) {
            this.num_sem_estoque = this.num_sem_estoque + 1;
          }

          this.saveComplate();
        } else {
          this.saveError();
        }
      },
      (error) => {
        this.saveError();
      }
    );
  }

  onImport() {
    this.modalImportOpen = true;
  }

  onCancelModalImport(bool) {
    this.modalImportOpen = false;
  }

  onChangeImport(bool) {
    this.changedImportFileCmp = bool;
  }

  onSuccessImport(file) {
    // this.files.unshift(file);
  }

  onSendFile() {
    if (this.changedImportFileCmp) {
      this.importFileCmp.onSubmit();
    }
  }
}
